import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../core/services/local-storage.service';
import { Component } from '@angular/core';
import { environment } from '../../../environment/environment';
@Component({
  selector: 'app-footer-unauthenticated',
  templateUrl: './footer-unauthenticated.component.html',
  styleUrls: ['./footer-unauthenticated.component.css'],
})
export class FooterUnauthenticatedComponent {
  constructor(private localStorageService: LocalStorageService) {}
  env = environment;
  typeintervenant: string | null | number =
    this.localStorageService.getData('typeintervenant');
  connectedUser: string | null | number =
    this.localStorageService.getData('userConnected');

    redirect(){
      window.open('https://wegestu.com/a-propos/', '_blank','noopener,noreferrer');
    }

    openEmail(): void {
      window.location.href = 'mailto:contact@wegestu.com';
    }
}
